module.exports = __webpack_public_path__ + "static/media/img_jerusalen.3f04dc48.jpg";